export enum STATSIG_FEATURE_GATES {
	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/rovo-ext_announcement_banner_enabled
	// FG for toggling announcement banner. Please don't remove it.
	ANNOUNCEMENT_BANNER_ENABLED = 'rovo-ext_announcement_banner_enabled',
	// https://switcheroo.atlassian.com/ui/gates/558015fa-530c-4edd-9680-73da3160e8bf/key/rovo-ext_bannerman_enabled
	// FG for toggling Bannerman dynamic banner system. Please don't remove it.
	BANNERMAN_ENABLED = 'rovo-ext_bannerman_enabled',
	// https://switcheroo.atlassian.com/ui/gates/43c7705c-5d94-4fbd-99cb-cc02861da827/key/rovo-ext-feature-gate-by-extension-version
	FEATURE_GATE_BY_EXTENSION_VERSION = 'rovo-ext-feature-gate-by-extension-version',
	// https://switcheroo.atlassian.com/ui/gates/ff6bc152-83cf-429c-bd05-1df4a24d8d5f/key/hide_rovo_extension_ntp_welcome_header
	SHOW_ROVO_EXTENSION_NTP_WELCOME_HEADER = 'hide_rovo_extension_ntp_welcome_header',
	// https://switcheroo.atlassian.com/ui/gates/d10cc0f3-f68b-436b-93d5-7f40ecfcd670/key/rovo_extension_safe_post_window
	SAFE_POST_WINDOW = 'rovo_extension_safe_post_window',
	//https://switcheroo.atlassian.com/ui/gates/7c652b22-efe3-4db0-a485-cc9d6e988569/key/navx_uc_rovo_extension_platform_creation_enabled
	/**
	 * Controls cross-app creation for team/goal/project
	 * Not intended to release for all. Internal testing within NavX Team
	 */
	NAVX_PLATFORM_CREATION_ENABLED = 'navx_uc_rovo_extension_platform_creation_enabled',
	// SBS (Side-by-Side) evaluation gates
	/** Master on/off gate for the SBS evaluation system. */
	SBS_ENABLED = 'rovo-ext_sbs_enabled',
	/** Whether this user has ChatGPT Enterprise access and is eligible for ChatGPT SBS pairings. */
	SBS_CHATGPT_ELIGIBLE = 'rovo-ext_sbs_chatgpt_eligible',
	// https://switcheroo.atlassian.com/ui/gates/aa878173-3ca2-47e1-b18c-0cc707b269b7/key/rovo-extension-session-replay-gate
	// Feature gate replacing the rovo-extension-session-replay experiment for controlling session replay.
	SESSION_REPLAY = 'rovo-extension-session-replay-gate',
	// https://switcheroo.atlassian.com/ui/gates/7639bf18-5d1c-46bf-a870-9f7912a3b88a/key/rovo_extension_consent_gate
	// Enables consent banner and respecting user privacy settings when accessing browser storage, incl. through third-party scripts.
	CONSENT = 'rovo_extension_consent_gate',
	// https://switcheroo.atlassian.com/ui/gates/4b817020-c8b0-476e-99ff-db815afaf357/key/rovo-ext_context_bridge
	// Carries Rovo product context (Confluence page and editor selection) into the side-panel chat
	// and relays chat write actions back to the page. `config.product` stays 'rovo' either way — the
	// chat never impersonates the host product (see ASIMO-4853).
	// Must match `BRIDGE_FEATURE_GATE` in `@atlaskit/rovo-triggers/extension-context-bridge/constants` —
	// the platform Host evaluates the same gate with the platform feature-flag client, so the gate has
	// to be targeted at both `rovo-extension-web` and `confluence` to have any effect.
	// Write additionally relies on the sibling platform gate `rovo-ext_aifc_enabled` (AIFC write path).
	// https://switcheroo.atlassian.com/ui/gates/0d43e585-b022-4c36-ae4d-1f40d7b78d05/key/rovo-ext_aifc_enabled
	EXT_CONTEXT_BRIDGE = 'rovo-ext_context_bridge',
}
export enum STATSIG_DYNAMIC_CONFIGS {
	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo-ext_debug_menu_config
	DEBUG_MENU_CONFIG = 'rovo-ext_debug_menu_config',
	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo_extension_demo_search_config
	DEMO_SEARCH_CONFIG = 'rovo_extension_demo_search_config',
	// https://switcheroo.atlassian.com/ui/configurations/eb2765ed-768b-48fc-9379-a601ce475aff/key/rovo_extension_context_menu_blocklist
	// String list of hosts the Rovo Context Menu's visible surfaces must not render on.
	CONTEXT_MENU_BLOCKLIST = 'rovo_extension_context_menu_blocklist',
}
